<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem class="ml-3" label="报告修改统计" >
        </FormItem>
        <FormItem label="开始时间" >
          <Col span="12">
            <DatePicker
              type="date"
              @on-change="table.search.begintime = $event"
              v-model="table.search.begintime"
              placeholder="选择开始时间"
            ></DatePicker>
          </Col>
        </FormItem>
        <FormItem label="结束时间">
          <Col span="12">
            <DatePicker
              type="date"
              @on-change="table.search.endtime = $event"
              v-model="table.search.endtime"
              placeholder="选择结束时间"
            ></DatePicker>
          </Col>
        </FormItem>
        <!-- <FormItem label="选择医院">
          <Select placeholder="请选择" v-model="table.search.DicCode" class="w-250" clearable> 
            <Option
              v-for="(item, index) in DicSelect"
              :value="item"
              :key="index"
              >{{ item }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="检查类型">
          <Select placeholder="请选择" v-model="table.search.DicCode" class="w-250" clearable> 
            <Option
              v-for="(item, index) in ExamTypeSelect"
              :value="item.dictionaryValue"
              :key="index"
              >{{ item.dictionaryValue }}</Option
            >
          </Select>
        </FormItem> -->
      </Form>
      <div>
          <Button class="mr-3" type="success" @click="search">查询</Button>
          <!-- <Button class="mr-3" type="primary" @click="exportExcel">导出</Button> -->
      </div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
    ></DataTable>
    <!-- 弹框 -->
    <Modal
        v-model="modal1"
        title="详情"
        width="800px"
        @on-ok="ok"
        @on-cancel="cancel">
        <!-- <Table
          :loading="loading"
          border
          stripe :columns="columns1"
          :data="data1"
          size="small"
          :height="0"
          disabled-hover
          highlight-row
        ></Table> -->
         <p class="ppp">患者姓名:{{data3.patientName}}</p>
                <p class="ppp">年龄:{{data3.patientAge}}</p>
                <p class="ppp">医院:{{data3.organName}}</p>
                <p class="ppp">检查号:{{data3.accessionNumber}}</p>
                <p class="ppp">科室:{{data3.examDepartment}}</p>
                <p class="ppp">诊断类型:{{data3.examTypeName}}</p>
                <p class="ppp">修订医生:{{data3.reviseDR}}</p>
                <p class="ppp">修订时间:{{data3.reviseDate}}</p>
                <p class="ppp">修订次数:{{data3.reviseNum}}</p>
                <p class="ppp">检查所见:{{data3.findings}}</p>
                <p class="ppp">诊断报告:{{data3.diagnosis}}</p>
          <!-- @on-selection-change="selectionChange"
          @on-row-click="onRowClick" -->
          <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable_report.vue";
// import DataTable from "@/components/NoPageDataTable.vue";

export default {
  components: { DataTable },
  data: function () {
    return {
      // 新增
       DicSelect: ['测试医院1','测试医院2'],
      //  ExamTypeSelect:['测试CT','测试MG','测试DX'],
       ExamTypeSelect:[],
        modal1: false,
         columns1: [
              {
                  title: '姓名',
                  key: 'name'
              },
              {
                  title: '年龄',
                  key: 'age'
              },
              {
                  title: '地址',
                  key: 'address'
              }
          ],
          loading: false,
          data3:{},
          data1: [
              {
                  name: '王小明',
                  age: 18,
                  address: '北京市朝阳区芍药居'
              },
              {
                  name: '张小刚',
                  age: 25,
                  address: '北京市海淀区西二旗'
              },
              {
                  name: '李小红',
                  age: 30,
                  address: '上海市浦东新区世纪大道'
              },
              {
                  name: '周小伟',
                  age: 26,
                  address: '深圳市南山区深南大道'
              }
          ],

      EmailSendFlagSelect: [],
      currentData: {},
      detailModal: false,
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "检查医院", key: "organName" },
          { title: "检查号", key: "accessionNumber" },
          { title: "检查科室", key: "examDepartment" },
          { title: "诊断类型", key: "examTypeName" },
          { title: "修订医生", key: "reviseDR" },
          { title: "修订时间", key: "reviseDate" },
          { title: "操作", key: "reviseNum" ,
            render: (h, params) => {
                return h('div', {
                    style: {
                      color: '#2d8cf0',
                      width: '50px',
                      height: '20px',
                      cursor: 'pointer',
                    },
                    on: {
                        click: () => {
                            console.log('点击数量',params)
                            this.modal1 = true
                            this.table2(params.row)
                        }
                    }
                // }, `${params.row.reviseNum}`);
                }, `查看`);
            }
          },
          // {
          //   title: '操作',
          //   key: 'action',
          //   fixed: 'right',
          //   width: 120,
          //   // render () {
          //   //     return `<i-button type="text" size="small">查看</i-button>`;
          //   // }

          //   render: (h, params) => {
          //       return h('div', {
          //           style: {
          //             color: '#FF7D41',
                     
          //           },
          //           on: {
          //               click: () => {
          //                   console.log('yyy',params)
          //                   this.modal1 = true
          //               }
          //           }
          //       }, '点击');
          //   }
          // }
        ],
        // apiUrl: "datastatistics/getStatisticsByHosptialExamTypeList",
        apiUrl: "client/reviseList",  //修订统计
        search: {
          // ExamOrganCode: "",
          begintime: "",
          endtime: "",
          // DicCode:''
        },
      },
    };
  },

  activated: function () {
    const date = new Date();
    const years = date.getFullYear();
    const today = date.getDate();
    const currentMonth_begin = date.getMonth() ;
    const currentMonth_end = date.getMonth() + 1;
    const all_data_begin = years + '-' + currentMonth_begin + '-'+ today
    const all_data_end = years + '-' + currentMonth_end + '-'+ today
    this.table.search.begintime = '2021-4-7' //all_data_begin
    this.table.search.endtime = all_data_end
    console.log('时间',this.table.search);


    this.clientLogTypeSelect = this.$common.getJsonData("clientLogType");
    let organCode = localStorage.getItem("organCode");
    let userType = localStorage.getItem("userType");
      console.log('organCode',organCode);
    if (!userType.indexOf("管理员")) {
      this.table.search.ExamOrganCode = organCode;
    }

    //获取检查类型数据 
    //  var _this = this;
    this.$common.getDictionaryByCode("JCLX").then((data) => {
      // console.log('data数据',data);
      this.ExamTypeSelect = data;
    });
    this.$refs.dataTable.initload();
  },

  methods: {
    // 新增
     ok () {
        // this.$Message.info('点击了确定');
    },
    cancel () {
        // this.$Message.info('点击了取消');
    },
    //请求弹框2 的表中数据 
    table2(para){
      console.log('cdd',para);
      this.$api.get(`client/reviseInfo?ReportID=${para.reportID}`).then((rsp) => {
      // this.$api.get(`client/criticallist?ExamDepartment=中医科（皮肤科）&ExamTypeName=ECG&PageIndex=0&pageSize=10`).then((rsp) => {
        if (rsp != false) {
          this.data3= rsp.data[0];
          console.log('修改修改表格33数据',this.data3);
          // this.loading = false;
        }
      });
    },
    search: function () {
      // this.$refs.dataTable.initload();
      this.$refs.dataTable.initload();
      // console.log('时间',this.table.search);
    },
    // 导出Excel
    exportExcel: function () {
      var urls ="/"+ this.table.apiUrl + "exportExcel?";
      let baseUrl = localStorage.getItem("baseURL");
      const Qs = require("qs");
      let params = Qs.stringify(this.table.search);
      let url = baseUrl + urls + params;
      console.log(url);
      window.open(url);
    },
    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = data;
    },
  },
};
</script>
<style scoped>
.ppp{
  /* border: 1px red solid; */
  margin-bottom: 8px;
  /* background-color: #e71818; */
  border-radius: 50%;
  
}
</style>